import { FC, useState, useContext, useEffect } from 'react';
import { User } from 'lucide-react';
import { HeaderProps } from '../../types/types';
import GlobalAuthenticatedContext from '../common/contexts/GlobalAuthenticatedContexts';
import { useLocation } from 'react-router'
const Header: FC<HeaderProps> = () => {
  const { globalAuthenticated: appContext } = useContext(GlobalAuthenticatedContext);
  const location = useLocation();
  const [showUsername, setShowUsername] = useState(() => {
    return localStorage.getItem('showUsername') === 'true'
  });

  const [userName, setUserName] = useState(() => {
    return localStorage.getItem('userName') || ''
  });

  // Effect to handle persistence across refreshes
  useEffect(() => {
    // Set username from context if available
    if (appContext && appContext.user && appContext.user.name) {
      setUserName(appContext.user.name);
      localStorage.setItem('username', appContext.user.name)
    } else {
      const saved = localStorage.getItem('username');
      if (saved) setUserName(saved);
    }
  }, [appContext]);

  const handleClick = () => {

    setShowUsername((prev) => {
      const newState = !prev;
      localStorage.setItem('showUsername', newState.toString());
      return newState;

    });
    // Save state to localStorage for persistence across refreshes
  };
  const getPageTitle = () => {
    const path = location.pathname;
    if (path.includes("/setup")) return "Initial Setup";
    if (path.includes("/sharepoint")) return "SharePoint Configuration";
    if (path.includes("/knowledge-base")) return "Knowledge Base Management";
    if (path.includes("/trigger-config")) return "Trigger Configuration";
    if (path.includes("/logs")) return "Activity Logs";
    if (path.includes("/releasenotes")) return "Release Notes";
    if (path.includes("/help")) return "Help & Support";
    if (path.includes("/login")) return "Login";
    if (path === "/" || path.includes("/dashboard")) return "Dashboard";
    return "Dashboard"; // fallback
  };

  return (
    <header className="bg-white shadow-sm fixed top-0 right-0 left-0 z-10 ml-64">
      <div className="px-6 py-4 flex justify-between items-center">
        <h1 className="text-2xl font-semibold text-gray-800">
          {getPageTitle()}
        </h1>
        <div className="flex items-center space-x-4">

          <button
            className="text-gray-500 hover:text-gray-700 bg-gray-200 rounded-full p-1 flex items-center justify-center transition-colors"
            onClick={handleClick}
          >
            <User size={20} />
            {showUsername && userName && (
              <span className="ml-2 text-sm font-medium">{userName}</span>
            )}
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;